import * as React from "react";
import { forwardRef } from "react";
const SvgForgerock = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#3c3c3c", rx: 4 }), /* @__PURE__ */ React.createElement("path", { fill: "#ff5722", d: "M8 6h8v4H8z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ff9800", d: "M10 10h4v8h-4z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffc107", d: "M6 14h4v4H6zM14 14h4v4h-4z" }));
const ForwardRef = forwardRef(SvgForgerock);
export default ForwardRef;
